module.exports = __webpack_public_path__ + "static/media/potter-quiz.6fe4b97f.jpg";